<template>
    <div>
        <div class="leaseSmart">
            <img src="~assets/image/lease/leaseSmart.png" alt />
        </div>
        <div style="margin-top:50px">
            <footer-title :width="168">业务应用模式</footer-title>
        </div>
        <div class="mode">
            <div style="text-align: center">
                <img src="~assets/image/lease/maxMode.jpg" style="width: 75%" alt />
            </div>
        </div>
        <div style="margin-top:50px">
            <div class="textContent">
                <h2>托盘静态循环运营服务</h2>
                <p>指用户向托盘运营服务公司就近提取托盘供自己周转使用，用户使用完毕后，在原提取地址归还托盘，运营服务公司回收托盘后另行循环租赁给其他用户的服务过程；（同一主体、同一地址)</p>
                <p>托盘的静态循环包括以下两种方式：</p>
                <h3>相同托盘，标准静态租赁模式</h3>
                <p>用户提取托盘用于自身内部使用，租赁期满后，在同一地址，将起租批次托盘归还给托盘运营服务公司；</p>
                <h3>混同托盘，交换模式</h3>
                <p>用户在租赁期限内，为方便带托运输，与下游用户共用托盘，在货物交割时与下游用户进行托盘的等量互换，不改变租期不过户，租赁期满后，在原提取地址将起租批次同类托盘归还给托盘运营服务公司；</p>

            </div>
            <div style="margin-top:50px">
                <mode-icon :iconList="saveList" />
            </div>
        </div>

        <div style="margin-top:50px">
            <div class="textContent">
                <h2>托盘动态循环运营服务</h2>
                <p>指上游用户向托盘运营服务公司就近提取托盘，通过单元化物流，将托盘随货物转移给下游用户使用，下游用户使用完毕后，向托盘运营服务公司申请就近归还托盘的服务过程。</p>
                <p>托盘的动态循环主要包括以下两种方式：</p>

                <h3>流转模式</h3>
                <p>上游用户提取的托盘通过带托运输转移给下游用户后，通过转户实现上下游用户一还一借，托盘权责关系同步转移至下游用户，下游使用完毕后，由下游用户向托盘运营服务公司申请就近归还。</p>

                <h3>异地归还模式</h3>
                <p>上游用户提取的托盘通过带托运输转移给下游用户后，不进行托盘权责关系的转移，下游使用完毕后，托盘在下游暂存，由上游用户向托盘运营服务公司申请异地归还托盘。</p>

            </div>
            <!-- 图标 -->
            <mode-icon style="margin-top:50px" :iconList="envList" />
            <!-- <div style="margin-top:50px">
                <footer-title :width="70">案例</footer-title>
            </div> -->
            <!-- <dynamic-case :caseList="caseList" />    -->
        </div>

    </div>
</template>

<script>
import footerTitle from '@/components/footerTitle.vue'
import modeIcon from './modeIcon'
import dynamicCase from './dynamic-case.vue';

export default {
    components: { footerTitle, modeIcon, dynamicCase },
    data() {
        return {
            saveList: [
                { url: require('assets/image/lease/saveMoney.png'), title: "省钱" },
                { url: require('assets/image/lease/saveLabour.png'), title: "省力" },
                { url: require('assets/image/lease/saveMan.png'), title: "省人" },
                { url: require('assets/image/lease/saveHeart.png'), title: "省心" },
            ],
            envList: [
                { url: require('assets/image/lease/efficiency.png'), title: "提高作业效率" },
                { url: require('assets/image/lease/cycle.png'), title: "加快库存周转" },
                { url: require('assets/image/lease/goodsMessage.png'), title: "减少货物破损" },
                { url: require('assets/image/lease/manResource.png'), title: "节约人力成本" },
                { url: require('assets/image/lease/env.png'), title: "低碳保护环境" },

            ]
        }
    }

}
</script>

<style lang="scss" scoped>
.leaseSmart {
    width: 100%;
    height: 186px;
    margin-top: 20px;
    img {
        width: 100%;
    }
}
.mode {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 28px;
    div {
        width: 1035px;
        img {
            width: 1035px;
        }
    }
}
.textContent {
    p, h2, h3{
        margin-top: 10px;
    }
}
</style>